import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue-demi';
import { useMagicKeys, onClickOutside } from '@vueuse/core';
import { AbIcon } from '../';
interface Props {
  width?: string;
  closeable?: boolean;
}
interface Emits {
  (e: 'closed'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbModal',
  props: {
    width: { default: '700px' },
    closeable: { type: Boolean, default: false }
  },
  emits: ["closed"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'closed'): void;
}), expose: any, slots: any, attrs: any }) {





const { escape } = useMagicKeys();
const isOpen = ref(false);

const close = () => {
  if (isOpen.value === false) return;
  isOpen.value = false;
  emit('closed');
};

const open = () => {
  if (isOpen.value === true) return;
  isOpen.value = true;
};

expose({
  open,
  close,
});

watch(escape, (v) => {
  if (!v) return;
  if (isOpen.value === false) return;
  close();
});

const modal = ref(null);
onClickOutside(modal, () => close());

return { __sfc: true,emit, escape, isOpen, close, open, modal, AbIcon }
}

})